// Pure helpers for the password show/hide eye toggle (Gordon's universal
// password-eye law). Kept as standalone pure functions so the toggle's
// user-facing contract (accessible label + resulting input type) is unit-
// testable without a DOM/render harness — this repo's tests are pure-logic.

/**
 * Accessible label for the eye toggle button.
 * @param {boolean} showPassword - whether the value is currently revealed.
 * @returns {"Hide password"|"Show password"}
 */
export const passwordToggleLabel = (showPassword) =>
  showPassword ? "Hide password" : "Show password";

/**
 * The <input type> that corresponds to the current reveal state.
 * @param {boolean} showPassword - whether the value is currently revealed.
 * @returns {"text"|"password"}
 */
export const passwordInputType = (showPassword) =>
  showPassword ? "text" : "password";
